// Création de l'objet à envoyer au back
import { getArrayFilesToSend } from '../../../../../utils/fileFunction';

const formaterCompleterDemandePiecesJointes = async (
    pieceIdentite,
    permisDeChasse,
    validationPermisChasserFichier,
    licenceDeTir,
    licenceDeBallTrap,
    licenceDeSki,
    justificatifDeDomicile,
    certificatMedical,
    uuidDeclaration,
    attestationHebergementFichier,
    pieceIdentiteHebergeurFichier,
    justificatifDomicileHebergeurFichier,
) => {
    return {
        uuidDeclaration,
        pieceIdentite: pieceIdentite ? await getArrayFilesToSend(pieceIdentite) : null,
        permisDeChasse: permisDeChasse ? await getArrayFilesToSend(permisDeChasse) : null,
        validationPermisChasserFichier: validationPermisChasserFichier
            ? await getArrayFilesToSend(validationPermisChasserFichier)
            : null,
        licenceDeTir: licenceDeTir ? await getArrayFilesToSend(licenceDeTir) : null,
        licenceDeBallTrap: licenceDeBallTrap ? await getArrayFilesToSend(licenceDeBallTrap) : null,
        licenceDeSki: licenceDeSki ? await getArrayFilesToSend(licenceDeSki) : null,
        justificatifDeDomicile: justificatifDeDomicile
            ? await getArrayFilesToSend(justificatifDeDomicile)
            : null,
        certificatMedical: certificatMedical ? await getArrayFilesToSend(certificatMedical) : null,
        attestationHebergementFichier: attestationHebergementFichier
            ? await getArrayFilesToSend(attestationHebergementFichier)
            : null,
        pieceIdentiteHebergeurFichier: pieceIdentiteHebergeurFichier
            ? await getArrayFilesToSend(pieceIdentiteHebergeurFichier)
            : null,
        justificatifDomicileHebergeurFichier: justificatifDomicileHebergeurFichier
            ? await getArrayFilesToSend(justificatifDomicileHebergeurFichier)
            : null,
    };
};

export default formaterCompleterDemandePiecesJointes;
